import React, { Component } from 'react';
import '../css/backAgente.css';
import { Col, Row, Card, CardBody, } from 'reactstrap';
import HeaderComp from "../components/HeaderAgente"
import TablaTurnos from "../components/TablaTurnosAgente"
import DatosAtencion from "../components/DatosAtencionAgente"
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const mapStateToProps = state => {
  return { agente: state.agente };
};

class HomeAgente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agenteOcupado: false,
    };
    this.ocuparAgente = this.ocuparAgente.bind(this);
  }

  ocuparAgente(booleano) {
    this.setState({
      agenteOcupado:booleano
    })
  }

  componentDidMount() {
    document.title = "DigiturnoKL - Agentes"
  }

  render() {
    //console.log(this.props)
    if (this.props.agente.nombreAgente === undefined || this.props.agente === undefined || this.props.agente === {}) {
      return <Redirect to={{ pathname: '/Cliente' }} />
    }
    return (

      <div className="cuerpo envoltura">
        <Row>
          <Col xs={{ size: 12 }}>
            <HeaderComp agenteOcupado={this.state.agenteOcupado}></HeaderComp>
          </Col>
        </Row>
        <Row>
          <Col xs={{ size: 10, offset: 1 }}>
            <Card>
              <CardBody>
                <Row>
                  <Col lg={{ size: 12 }}>
                    <DatosAtencion ocuparAgente={this.ocuparAgente}></DatosAtencion>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col lg={{ size: 12 }}>
                    <TablaTurnos></TablaTurnos>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

    );
  }
}

export default connect(mapStateToProps)(HomeAgente);
